export default 'Join now'
